// eslint-disable-next-line simple-import-sort/imports -- this must be imported first
import { initWdyr } from './dev/wdyr';

import './bootstrap/publicPath';

import { createRoot } from 'react-dom/client';

import oneObject from '#/bootstrap/oneObject';
import devtoolsApi from '#/dev/devtools';
import { ConfigProvider } from '#/hooks/useConfig';
import { ignoreError } from '#/service/utils';

import App from './App';
import GlobalState from './components/GlobalState';
import GlobalStyle from './components/GlobalStyle';
import { translationActions } from './store/translation/translation.store';

// TODO After GlobalState was completely removed, extract all of the providers
//  and the logic for their props from here into a new component.

const config = oneObject.config;

if (process.env.goal === 'local') {
  devtoolsApi.overrideConsole();
  devtoolsApi.setContexts({ config });
  devtoolsApi.setWdyr(initWdyr);
}

translationActions.load(config.i18nextConfig).catch(ignoreError);

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
  <ConfigProvider config={config}>
    <GlobalState>
      <GlobalStyle />
      <App />
    </GlobalState>
  </ConfigProvider>
);
